var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello-ezuikit-js"},[_c('div',{style:(_vm.styleObject),attrs:{"id":_vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }